import { render, staticRenderFns } from "./supplier-requirement-supplier-reqs-a-edit-table.vue?vue&type=template&id=2360806a&scoped=true&"
import script from "./supplier-requirement-supplier-reqs-a-edit-table.vue?vue&type=script&lang=js&"
export * from "./supplier-requirement-supplier-reqs-a-edit-table.vue?vue&type=script&lang=js&"
import style0 from "./supplier-requirement-supplier-reqs-a-edit-table.vue?vue&type=style&index=0&id=2360806a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2360806a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2360806a')) {
      api.createRecord('2360806a', component.options)
    } else {
      api.reload('2360806a', component.options)
    }
    module.hot.accept("./supplier-requirement-supplier-reqs-a-edit-table.vue?vue&type=template&id=2360806a&scoped=true&", function () {
      api.rerender('2360806a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl44/partials/supplier-requirement-supplier-reqs-a-edit-table.vue"
export default component.exports